import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AskTeacherService {
  constructor(private http: HttpClient) {}

  sendFeedback(message: string, lessonId?: number): Observable<any> {
    return this.http.post('/feedback/request/save', {
      courseId: lessonId,
      question: message,
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/ask-teacher.service.ts